import { atBqnTarget } from "common/api";

// The statistics of the BQN selected in the header, or of the whole cluster.
// The three DoS views share these two commands.

export const dosVolumeRetrieval = ({ hours, mode, bqnId }) =>
  ifCl.run(atBqnTarget(`show statistics dos volume hours ${hours}`, mode, bqnId));

export const dosSynRetrieval = ({ hours, mode, bqnId }) =>
  ifCl.run(atBqnTarget(`show statistics dos syn hours ${hours}`, mode, bqnId));
